// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bottom-headers-wrapper{position:absolute;left:0;right:0;bottom:0;pointer-events:none}.BottomHeader{display:inline-block;width:100%;pointer-events:auto}.BottomHeader.closed{display:none}.BottomHeader.stroke{border-top:1px solid var(--gray-5)}", ""]);
// Exports
module.exports = exports;
